import React, { useContext, useRef, useEffect  } from 'react';
import { ProjectContext } from '../contexts/Project';
import '../styles/StepComponent.css'; // Імпорт стилів, які ви надали
import botImg from '../img/bot_helper.png';
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { IoMdArrowDropupCircle } from "react-icons/io";


const StepComponent = ({ step, data, setData }) => {
    const inputRef = useRef(null);
        const {advice, toggleAdvice} = useContext(ProjectContext)
      const handleChange = (e) => {
                   setData({
                ...data,
                [step.key]: e.target.value,
            });
    };

    const setArrow = ()=> {
        toggleAdvice(!advice)
    }

    useEffect (()=> {
        if (inputRef.current) {
            inputRef.current.focus();
          }
    }, [])
    return (
        <div className="step-page">
            <div className="step-container">
                <h1>{step.label}</h1>
                <p>{step.placeholder}</p>
                <div className="questions">
                    <div className='advice'>
                    <img className='questions__img' src={botImg} alt="робот-козак" />
                    <h3>Потрібна підказка?</h3>
                   
                    { !advice ? 
                    <div className='text__arrow' ><span> Дивись мої підказки тут </span> <IoMdArrowDropdownCircle className='icon__arrow' onClick={setArrow} /></div>: 
                    <div className='text__arrow' ><span> Мої поради наступні: </span><IoMdArrowDropupCircle className='icon__arrow' onClick={setArrow}/> </div>} 
                  
                  
                   </div>
                  
                  {advice &&  <pre>{step.questions}</pre> }
                </div>
                <textarea className = 'answer'
                    value={data[step.key] || ''}
                    onChange={handleChange}
                    placeholder="Напиши свою відповідь тут..."
                    rows={5}
                    ref={inputRef}
                ></textarea>
            </div>
        </div>
    );
};

export default StepComponent;